import React from "react";

import { bemClassName } from "../../utils/bemClassName";
import { joinClassNames } from "../../utils/joinClassNames";
import { CellDisplayValues } from "../SearchResultsTable/BodyCell";
import DataProvider from "../../context/DataContext";
import Pagination, { PaginationProps } from "../Pagination/Pagination";
import { SearchCollectionConfig } from "../../types/context";
import SearchResults from "./SearchResults";
import ResultsSummary from "../SearchResultsSummary/SearchResultsSummary";
import SearchForm, { SearchFormProps } from "../SearchForm/SearchForm";
import { StatusValues } from "../ResourceStatus/ResourceStatus";

import "../../assets/styles/global.css";
import styles from "./SearchContents.module.css";

export type SearchResultsHeader = {
    label: string;
    columnKey: string;
    cellDisplay: CellDisplayValues;
    cellClassName?: string;
};

export type SearchResultsItem = {
    [key: string]: string | StatusValues | undefined;
    applicationDescription?: string;
    applicationId?: string;
    applicationNumber?: string;
    applicationReceivedDateFb?: string;
    applicationType?: string;
    description?: string;
    principalApplicationId?: string;
    resourceName?: string;
    resourceType?: string;
    status?: StatusValues | undefined;
    url?: string;
};

export type SearchContentsProps = {
    [key: string]:
        | string
        | PaginationProps
        | SearchFormProps
        | SearchCollectionConfig
        | string[]
        | undefined;
    routerBasename: string;
    pagination: PaginationProps;
    searchConfig: SearchCollectionConfig;
    searchForm: SearchFormProps;
};

export const defaultProps: SearchContentsProps = {
    routerBasename: "/",
    pagination: {
        maxPages: 5,
    },
    searchConfig: {
        endpoint: "",
        collection: "",
        profile: "_default",
        initialSort: "dmetastatus",
    },
    searchForm: {
        facetBlockId: "planning-search-facets",
        formAction: "",
        initialExpandFacets: true,
    },
};

export const SearchContents = ({
    pagination,
    searchConfig,
    searchForm,
}: SearchContentsProps) => {
    return (
        <DataProvider config={searchConfig} maxPages={pagination?.maxPages}>
            <div
                className={joinClassNames([
                    "find-a-panel",
                    "planning-panels-section",
                ])}
            >
                <div className="container">
                    <SearchForm {...searchForm} />
                    <div className="flex flex-col-reverse">
                        <div
                            className={joinClassNames([
                                bemClassName("find-a-panel", "search-result"),
                                styles.searchResults,
                            ])}
                        >
                            <ResultsSummary />
                            <SearchResults
                                collection={searchConfig.collection}
                            />
                            <Pagination {...pagination} />
                        </div>
                    </div>
                </div>
            </div>
        </DataProvider>
    );
};

export default SearchContents;
